"use client";

import styled from "@emotion/styled";

export const StyledTrimmedText = styled.p`
  text-box: trim-both cap alphabetic;
`;
